export const LINK_BP_USER = '@Banner/LINK_BP_USER';